module.exports = __webpack_public_path__ + "static/state.8c4097b8.png";